module.exports = __webpack_public_path__ + "img/cnu_gallery10.d9e9402c.jpg";